module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Детали транзакции\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'transaction-edit',
        params: {
          transaction_id: _vm.$route.params.transaction_id
        }
      }
    }
  }, [_vm._v("Редактировать информацию")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'client-details',
        params: {
          client_id: _vm.$route.params.client_id
        }
      }
    }
  }, [_vm._v("← Назад к Транзакциям")])], 1), _vm._v(" "), _c('transactionDetail', {
    attrs: {
      "transaction-id": _vm.$route.params.transaction_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-618b1112","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transaction/ClientTransactionDetails.vue
// module id = 656
// module chunks = 0